import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "notification-center" }
const _hoisted_2 = { class: "header-section" }
const _hoisted_3 = { class: "header-actions" }
const _hoisted_4 = { class: "notifications-list" }
const _hoisted_5 = { class: "notification-header" }
const _hoisted_6 = { class: "user-info" }
const _hoisted_7 = { class: "user-row" }
const _hoisted_8 = { class: "username" }
const _hoisted_9 = { class: "action-type" }
const _hoisted_10 = { class: "time" }
const _hoisted_11 = {
  key: 0,
  class: "notification-content"
}
const _hoisted_12 = { class: "actions" }
const _hoisted_13 = {
  key: 0,
  class: "loading"
}
const _hoisted_14 = {
  key: 1,
  class: "empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_OtherUserProfileModal = _resolveComponent("OtherUserProfileModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_page_header, {
      onBack: _ctx.goBack,
      content: "互动消息"
    }, null, 8, ["onBack"]),
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h2", null, "互动消息", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          disabled: _ctx.unreadCount === 0,
          onClick: _ctx.markAllAsRead,
          type: "primary",
          round: ""
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" 全部标记为已读 ", -1)
          ]))]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_el_popconfirm, {
          title: "确认清空所有消息吗？此操作不可撤销！",
          onConfirm: _ctx.clearAllNotifications,
          width: "260"
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_button, {
              disabled: _ctx.notifications.length === 0,
              type: "danger",
              round: ""
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" 清空消息 ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["onConfirm"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (item) => {
        return (_openBlock(), _createBlock(_component_el_card, {
          key: item.id,
          class: _normalizeClass(["notification-item", { unread: item.isRead === 0 }]),
          onClick: ($event: any) => (_ctx.viewNotification(item))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_avatar, {
                src: item.fromUserAvatar || '/default-avatar.png',
                size: 40,
                class: "user-avatar"
              }, null, 8, ["src"]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(item.fromUserName), 1),
                  _createElementVNode("div", _hoisted_9, [
                    (item.type === 1)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          type: "warning",
                          size: "small",
                          effect: "light"
                        }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode(" 点赞了你的帖子 ", -1)
                          ]))]),
                          _: 1
                        }))
                      : (item.type === 2)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            type: "warning",
                            size: "small",
                            effect: "light"
                          }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode(" 点赞了你的评论 ", -1)
                            ]))]),
                            _: 1
                          }))
                        : (item.type === 3)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 2,
                              type: "success",
                              size: "small",
                              effect: "light"
                            }, {
                              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                _createTextVNode(" 评论了你的帖子 ", -1)
                              ]))]),
                              _: 1
                            }))
                          : (item.type === 4)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 3,
                                type: "success",
                                size: "small",
                                effect: "light"
                              }, {
                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                  _createTextVNode(" 回复了你的评论 ", -1)
                                ]))]),
                                _: 1
                              }))
                            : (item.type === 5)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 4,
                                  type: "primary",
                                  size: "small",
                                  effect: "light"
                                }, {
                                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                    _createTextVNode(" 关注了你 ", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : (item.type === 6)
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 5,
                                    type: "danger",
                                    size: "small",
                                    effect: "light"
                                  }, {
                                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                      _createTextVNode(" 收藏了你的帖子 ", -1)
                                    ]))]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formatDate(item.createTime)), 1)
              ])
            ]),
            (item.content)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(item.content), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_button, {
                size: "small",
                onClick: _withModifiers(($event: any) => (_ctx.deleteNotification(item.id)), ["stop"]),
                type: "danger",
                link: ""
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode(" 删除 ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 2
        }, 1032, ["class", "onClick"]))
      }), 128)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
              return _createElementVNode("div", {
                key: n,
                class: "skeleton-item"
              }, [
                _createVNode(_component_el_skeleton, {
                  rows: 3,
                  animated: ""
                })
              ])
            }), 64))
          ]))
        : _createCommentVNode("", true),
      (_ctx.notifications.length === 0 && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_el_empty, { description: "暂无互动消息" })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.total > 0)
      ? (_openBlock(), _createBlock(_component_el_pagination, {
          key: 0,
          class: "pagination",
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange,
          "current-page": _ctx.currentPage,
          "page-sizes": [10, 20, 30, 50],
          "page-size": _ctx.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total
        }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"]))
      : _createCommentVNode("", true),
    _createVNode(_component_OtherUserProfileModal, {
      modelValue: _ctx.showUserProfileModal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showUserProfileModal) = $event)),
      userId: _ctx.selectedUserId,
      onClose: _ctx.handleUserProfileClose
    }, null, 8, ["modelValue", "userId", "onClose"])
  ]))
}